import { Helmet } from "react-helmet";
import React from "react";
import { Box, Paper, Typography, Link } from "@mui/material";

const EFFECTIVE_DATE = "October 4, 2025";

const Privacy: React.FC = () => (
  <Box
    component="main"
    id="main-content"
    tabIndex={-1}
    sx={{
      flex: 1,
      width: "100%",
      minHeight: 0,
      py: 6,
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Paper
      sx={{
        p: { xs: 2, sm: 5 },
        maxWidth: 800,
        mx: "auto",
        borderRadius: 5,
        boxShadow: 5,
        animation: "slideUp 0.55s ease-out both",
        "@media (prefers-reduced-motion: reduce)": { animation: "none" },
      }}
    >
      <Helmet>
        <title>Privacy Notice | Rate My Cribs</title>
        <meta
          name="description"
          content="Minimal privacy notice for Rate My Cribs."
        />
        <link rel="canonical" href="https://ratemycribs.com/privacy" />
      </Helmet>

      <Typography
        variant="h4"
        fontWeight={800}
        color="primary"
        align="center"
        gutterBottom
      >
        Privacy Notice
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
        Effective Date: {EFFECTIVE_DATE}
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        We don’t provide account features and do not intentionally collect
        personal information through sign-up forms. We operate a reviews website
        and process only what’s necessary to run the site.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        What we may process
      </Typography>
      <ul
        style={{
          fontSize: 16,
          color: "#333",
          marginBottom: 16,
          paddingLeft: 20,
        }}
      >
        <li>
          <b>Server logs:</b> IP address, browser type, pages visited, and
          timestamps for security and reliability.
        </li>
        <li>
          <b>Emails you send us:</b> If you email{" "}
          <Link href="mailto:info.ratemycribs@gmail.com">
            info.ratemycribs@gmail.com
          </Link>
          , we receive your email address and message.
        </li>
        <li>
          <b>Cookies/analytics:</b> We may use strictly necessary cookies and
          optional analytics. If analytics are enabled, they’re used to
          understand traffic and improve the site.
        </li>
        <li>
          <b>User Content:</b> Reviews and comments you post are public. Don’t
          include personal information you wouldn’t want public.
        </li>
      </ul>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        How we use information
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        To operate, secure, troubleshoot, and improve the site; to respond to
        messages; and to moderate content consistent with our Terms.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        Sharing
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        We may share data with service providers that host our site, deliver
        content (e.g., CDNs), or provide analytics, subject to confidentiality
        obligations. We may disclose information if required by law or to
        protect rights, safety, and security.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        Data retention
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Logs are kept for a limited period necessary for security and
        operations. Emails are retained as needed to address your inquiry.
        Public reviews remain visible unless removed under our moderation
        policy.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        Children
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        The site is for users 18+ and not directed to children.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        Contact
      </Typography>
      <Typography variant="body1">
        Questions? Email{" "}
        <Link href="mailto:info.ratemycribs@gmail.com">
          info.ratemycribs@gmail.com
        </Link>
        .
      </Typography>
    </Paper>
  </Box>
);

export default Privacy;
